import React from 'react'

export default function ExternalMainPage() {
  return <div>ExternalMain</div>
}
